import React from 'react'
import {connect} from 'react-redux'

class DataLoader extends React.Component {


  constructor(){
    super()


    let serverURL;

    //console.log(window.location.hostname ==='localhost');
    /*

    (window.location.hostname ==='localhost')?
      serverURL = '//thefyzz:8888/'
    : serverURL = '/wp/'

    */

    //serverURL = '//thefyzz.stageserver.co.uk/wp/'
    // live
    serverURL = '//www.thefyzz.com/wp/'

    this.state = {
        serverURL,
        loaded:false,
        pageNumber:1
    }

    this.loadFilms =   this.loadFilms.bind(this)
    this.filmDataLoaded =   this.filmDataLoaded.bind(this)

  }

  loadFilms(){

    let url = this.state.serverURL +'wp-json/wp/v2/project?per_page=100&page='+this.state.pageNumber

    /*
    let tempNonce = 'dabaaf698a'

    let headers = {
            method: 'GET',
            credentials: 'Access-Control-Allow-Headers',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': tempNonce,
            }
          }
          */

      fetch(url)
        .then(results => results.json())
        .then(array => {
          this.filmDataLoaded(array)

        })
  }



  filmDataLoaded(array){



    if(array.length){
      this.props.setFilmData(array)
      if(this.props.loadAll!=='true'){
        this.setState({loaded:true})
        //console.log("LOADED FILMS");
      }

      //console.log(array.length,this.props.loadAll);

    }else{
      if(this.props.loadAll==='true'){
        this.setState({loaded:true})
      }
      //console.log("All Films Loaded");
    }


    if(array.length){
      if(array.length===100){
        let pageNumber = this.state.pageNumber + 1
        this.setState({pageNumber});
        this.loadFilms();
      }else{
        this.setState({loaded:true})
        //console.log("Film payload less than 100, All films loaded",this.state.loaded);

      }
    }


  }


  loadOptionsPage(){

    let url = this.state.serverURL +'wp-json/acf/v2/options/'
      fetch(url)
        .then(results => results.json())
        .then(array => {
          this.optionsPageDataLoaded(array)

        })
  }
  optionsPageDataLoaded(array){

    this.props.setOptionsPageData(array)
    this.setState({loaded:true})

  }

  loadPages(){

    let url = this.state.serverURL +'wp-json/wp/v2/pages'
      fetch(url)
        .then(results => results.json())
        .then(array => {
          this.pagesDataLoaded(array)

        })
  }
  pagesDataLoaded(array){

    this.props.setPagesData(array)
    this.setState({loaded:true})

  }

  loadPeople(){

    let url = this.state.serverURL +'wp-json/wp/v2/people?per_page=100'
      fetch(url)
        .then(results => results.json())
        .then(array => {
          this.peopleDataLoaded(array)

        })
  }
  peopleDataLoaded(array){

    this.props.setPeopleData(array)
    this.setState({loaded:true})

  }

  loadTestimonials(){

    let url = this.state.serverURL +'wp-json/wp/v2/testimonials?per_page=100'
      fetch(url)
        .then(results => results.json())
        .then(array => {
          this.testimonialsDataLoaded(array)

        })
  }
  testimonialsDataLoaded(array){

    this.props.setTestimonialData(array)
    this.setState({loaded:true})

  }



  componentWillMount(){

    if(this.props.load==='films'){
      (this.props.filmData)?
        this.setState({loaded:true})
        :
        this.loadFilms();
    }

    // This is loading the options page
    if(this.props.load==='menu'){
      (this.props.optionsData)?
        this.setState({loaded:true})
        :
        this.loadOptionsPage();

    }

    if(this.props.load==='pages'){
      (this.props.pagesData)?
        this.setState({loaded:true})
        :
        this.loadPages();

    }

    if(this.props.load==='people'){
      (this.props.peopleData)?
        this.setState({loaded:true})
        :
        this.loadPeople();

    }

    if(this.props.load==='testimonials'){
      (this.props.testimonialData)?
        this.setState({loaded:true})
        :
        this.loadTestimonials();

    }

  }

  componentWillUpdate(){

  }


  render () {
    return(
      <div>

      { this.state.loaded?
          this.props.children
        :
        <div className="loading">Loading</div>
      }

      </div>
    )
  }
};

const mapStateToProps = (state)  => {

    const filmData = state.filmData
    const optionsData = state.optionsData
    const pagesData = state.pagesData

    return {
        filmData,
        optionsData,
        pagesData
    }
}

const mapDispatchToProps = (dispatch) => {

      return {
      setFilmData:(data)=>{
        //console.log('ScrollIndex',index,max,dir)
        dispatch({type:'ADD_FILM_DATA', payload:data})
      },

      setOptionsPageData:(data)=>{
        //console.log('ScrollIndex',index,max,dir)
        dispatch({type:'ADD_OPTIONS_DATA', payload:data})
      },
      setPagesData:(data)=>{
        //console.log('ScrollIndex',index,max,dir)
        dispatch({type:'ADD_PAGES_DATA', payload:data})
      }
      ,
      setPeopleData:(data)=>{
        //console.log('ScrollIndex',index,max,dir)
        dispatch({type:'ADD_PEOPLE_DATA', payload:data})
      },

      setTestimonialData:(data)=>{
        //console.log('ScrollIndex',index,max,dir)
        dispatch({type:'ADD_TESTIMONIAL_DATA', payload:data})
      },


    }
  }


export default connect(mapStateToProps,mapDispatchToProps)(DataLoader)



// WEBPACK FOOTER //
// ./src/modules/data/DataLoader.js